export const apiUrl = 'https://boardsapistaging.visionslive.com/';
export const vlqrApiUrl = 'https://apistaging.visionslive.com/VL';
export const clientUrl = 'https://clientstaging.visionslive.com';
